// QR 코드에 담기는 값. 별도 QR 생성 API 없이 프론트에서 생성한다.
// 스캔 시 얻는 문자열: {"version":1,"deviceId":"<장비 ID>","storeId":"<매장 ID>"}
export const QR_VERSION = 1;

export function buildQrValue({ deviceId, storeId }) {
    return JSON.stringify({
        version: QR_VERSION,
        deviceId,
        storeId,
    });
}
